import clsx from 'clsx'
import { PropsWithChildren } from 'react'

interface InputLabelProps extends PropsWithChildren {
  className?: string
  htmlFor?: string
}

export default function InputLabel({
  className,
  htmlFor = '',
  children,
}: InputLabelProps) {
  return (
    <label
      className={clsx(
        '[--foreground-rgb:theme(colors.neutral-700)] type-body-10 ',
        className,
      )}
      htmlFor={htmlFor}
    >
      {children}
    </label>
  )
}
